module.exports = __webpack_public_path__ + "media/home/law-4b93ddce.png";